<template>
  <ElSelect
    :value="value"
    filterable
    placeholder="Select Business Activity"
    autocomplete="nope"
    @change="handler"
  >
    <ElOption
      v-for="(label, code) in industryCodes"
      :key="code"
      :label="label"
      :value="code"
    />
  </ElSelect>
</template>

<script>
import industries from '@/config/datalists/industries.js'

export default {
  name: 'Industry',
  props: {
    value: {
      type: String,
      default: ''
    },
    vuelidate: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    industryCodes() {
      return industries
    }
  },
  methods: {
    handler(newVal) {
      this.$emit('update:value', newVal)
      this.vuelidate()
    }
  }
}
</script>
